/**
 * Central navigation definitions used by Header and BottomNavigation.
 * Keep this aligned with `src/Routes.jsx` role guards to avoid dead/denied links.
 *
 * Active portal: Home | Jobs | Exchange Desk | Product Listing | Setting
 */

import { PORTAL_ROLES, hasWorkspaceAccess } from './portalAccess.mjs'

const FINANCE_NAV = { label: "ArtGold Admin", path: "/artgold-admin", icon: "Building2", workspace: "artgold_admin" };
const OPERATIONS_NAV = [
  FINANCE_NAV,
  { label: "Home", path: "/home", icon: "Home" },
  { label: "Jobs", path: "/jobs-management", icon: "CalendarDays", workspace: "jobs" },
  { label: "Exchange Desk", path: "/exchange-desk", icon: "Scale", workspace: "exchange_desk" },
  { label: "Product Listing", path: "/product-listing", icon: "Tag", workspace: "product_listing" },
];

const ADMIN_NAV = [
  ...OPERATIONS_NAV,
  { label: "Setting", path: "/settings", icon: "Settings" },
];

export function getPrimaryNavItems(role, { attendanceEmployee = false } = {}) {
  const r = role || null;
  const personal = attendanceEmployee === true && ['admin', 'manager', 'office'].includes(r)
    ? [{ label: 'My timesheet', path: '/timesheet', icon: 'Clock3' }] : [];

  if (r === "accountant") return [FINANCE_NAV];
  if (r === "admin") return [...ADMIN_NAV, ...personal];
  if (PORTAL_ROLES.includes(r)) return [...OPERATIONS_NAV.filter(item => !item.workspace || hasWorkspaceAccess(r, item.workspace)), ...personal];

  // No claim / retired claims: no nav (LandingRedirect shows the no-access notice).
  return [];
}

export function getBottomNavItems(role, options) {
  return getPrimaryNavItems(role, options);
}
